module.exports = __webpack_public_path__ + "img/handcursoricn.fc3db8e7.svg";